import _ from "lodash";
import {URL_API_CLIENT_MANAGEMENT, URL_API_CLIENT_MANAGEMENT_EDIT, URL_API_INVENTORY_MASTER, URL_API_INVENTORY_ADD_MASTER, 
  URL_API_INVENTORY_ADD_UPDATE, URL_API_INVENTORY_MAPPED_LIST, URL_API_INVENTORY_MAPPING, URL_API_REPORTS, URL_API_FREQUENCY} 
from '../apiHitFile';
import {showModalLogin} from '../Dashboard/UserActions';
export function Pending (){
  return{
  type: 'INVENTORY_PENDING',
  isPending:true
  }
}
export function InventoryAction(){
  return (dispatch, getState) => {
    const currentToken = getState().LoginReducer.session;  
    let headers = new Headers()
    headers.append("Authorization",currentToken);
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
    dispatch(Pending());
    fetch(URL_API_INVENTORY_MAPPED_LIST, {
      method: 'POST',
      headers : headers
    })
     .then(res=>res.json())
     .then(json => {
      if(json.status === 403){
        dispatch(showModalLogin())
       } else {
       dispatch(InventoryListSuceess(json))
       }
     })
     .catch(error => {
       dispatch(ErrorManage(error))
      })
    }  
}
export function InventoryListSuceess(data) {  
  if(data.status === 1001 && !_.isEmpty(data.value)){
  return{
    type: 'INVENTORY_ACTION',
    payload: data.value,
    isPending:false
    }
  } else {
    return{
      type: "INVENTORY_ERROR", 
      showerror:true, 
      errmessage:data.message,
      isPending:false
    }
  }
}
export function InventoryMaster(){
  return (dispatch, getState) => {
    const currentToken = getState().LoginReducer.session;  
    let headers = new Headers()
    headers.append("Authorization",currentToken);
    //headers.append('Content-Type','application/json');
    //headers.append('Accept','application/json');
    dispatch(Pending());
    fetch(URL_API_INVENTORY_MASTER, {
      //credentials:'include',
      method: 'POST',
      headers : headers
    })
     .then(res=>res.json())
     .then(json =>{
      if(json.status === 403){
        dispatch(showModalLogin())
       } else {
       dispatch(InventoryMasterSuceess(json))
       }
     })
     .catch(error => {
       dispatch(ErrorManage(error))
      })
    }
}
export function InventoryMasterSuceess(data){
  if(data.status === 1001 && !_.isEmpty(data.value)){
  return{
    type: 'INVENTORY_ACTION_MASTER',
    payload: data.value,
    isPending:false
    } 
  } else {
    return{
      type: "INVENTORY_ERROR", 
      showerror:true, 
      errmessage:data.message,
      isPending:false
    }
  }
}
export function InventoryMasterAddData(type, object, prop){  
  let names = (_.map(object, (x) => { return x.label }))  
  let obj = {'inventoryType':type.toUpperCase(), 'names':names , 'status':'ACTIVE'}
  return (dispatch, getState) => {
    const currentToken = getState().LoginReducer.session;  
    let headers = new Headers()
    headers.append("Authorization",currentToken);
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
    dispatch(Pending());
    fetch(URL_API_INVENTORY_ADD_MASTER, {
      method: 'POST',
      headers : headers,
      body:JSON.stringify(obj)
    }).then((res) => res.json()) 
    .then(json => {
      if(json.status === 403){
        dispatch(showModalLogin())
       } else if(json.status === 1001) {
        dispatch(InventoryMasterAddDataSuceess(prop, object))
       } else {
        dispatch(ErrorManage(json))
       }
     })
    .catch(error => {
      dispatch(ErrorManage(error))})
  }  
}
export function InventoryMasterAddDataSuceess(prop, object){
  return{
    type: 'INVENTORY_ACTION_MASTER_ADD',
    prop, object,
    isPending:false
  } 
}
export function InventoryMasterDataUpdate(index, prop, label, val, object){  
  let obj = {'inventoryType':label.toUpperCase(), id:val.id, name:prop, status:'ACTIVE'} 
  return (dispatch, getState) => {
    dispatch(Pending());
    const currentToken = getState().LoginReducer.session;  
    let headers = new Headers()
    headers.append("Authorization",currentToken); 
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
    fetch(URL_API_INVENTORY_ADD_UPDATE, {
      method: 'POST',
      headers : headers,
      body:JSON.stringify(obj)
    }).then((res) => res.json())
    .then(json => { 
      if(json.status === 403){
        dispatch(showModalLogin())
       } else {
        dispatch(InventoryMasterDataUpdateSuceess(index, prop, object))
       } })
    .catch(error =>{ dispatch(ErrorManage(error)) })
  }  
}
export function InventoryMasterDataUpdateSuceess(index, prop, object){
  return{
    type: 'INVENTORY_ACTION_MASTER_UPDATE',
    index, prop, object,
    isPending:false
  }
}
export function InventoryMasterDataEdit (prop, StatusOBj, type, object){  
  let obj = {'inventoryType':type.toUpperCase(), id:prop.id, name:prop.label, status:StatusOBj}
  return (dispatch, getState) => {
    const currentToken = getState().LoginReducer.session;  
    let headers = new Headers()
    headers.append("Authorization",currentToken); 
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
    dispatch(Pending());
    fetch(URL_API_INVENTORY_ADD_UPDATE, {
      method: 'POST',
      headers : headers,
      body:JSON.stringify(obj)
    }).then((res) => res.json()) 
    .then(json => {  
    if(json.status === 403){
      dispatch(showModalLogin())
     } else {
     dispatch(InventoryMasterDataEditSuceess(prop, StatusOBj, object))
     }})
    .catch(error => console.log(error))    
  }  
}
export function InventoryMasterDataEditSuceess(prop, StatusOBj, object){
  return {
    type: 'INVENTORY_ACTION_MASTER_EDIT',
    prop, StatusOBj, object,
    isPending:false
  } 
}
export function InventoryMasterDataMapping(prop){
  return (dispatch, getState) => {
    const currentToken = getState().LoginReducer.session;  
    let headers = new Headers()
    headers.append("Authorization",currentToken); 
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
    dispatch(Pending());
    fetch(URL_API_INVENTORY_MAPPING, {
      method: 'POST',
      headers : headers,
      body:JSON.stringify(prop)
    }).then((res) => res.json())
      .then((json) => {
        if(json.status === 403){
        dispatch(showModalLogin())
       } else {
       dispatch(ErrorManage(json))
       }
      }) 
      .catch(error => dispatch(ErrorManage(error)))      
  }  
}
export function InventoryClientAction(){
  return (dispatch, getState) => {
    const currentToken = getState().LoginReducer.session;  
    let headers = new Headers()
    headers.append("Authorization",currentToken);
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
    dispatch(ClientManagementPending());
    fetch(URL_API_CLIENT_MANAGEMENT, {
      method: 'POST',
      headers : headers
    })
    .then(res => res.json())
    .then((json) => {
        if(json.status === 403){
        dispatch(showModalLogin())
       } else {
        dispatch(ClientManagementSuccess(json))
       }
      })
   .catch(error => {
     dispatch(ErrorManage(error)) 
   })
  }
}
export function ClientManagementPending(){
  return {
      type: "CLIENT_MANAGEMENT_PENDING",
      isPending:true
  }
}
export function ClientManagementSuccess(clients){
  if(clients.status === 1001 && !_.isEmpty(clients.value)){ 
  return {
      type: "CLIENT_MANAGEMENT_SUCCESS",
      payload: clients,
      isPending: false
    }
  } else {
    return{
      type: "INVENTORY_ERROR", 
      showerror:true, 
      errmessage:clients.message,
      isPending:false
    }
  }
}
export function ClientManagementEdit(prop){ 
  return (dispatch, getState) => {
    dispatch(ClientManagementPending());
    const currentToken = getState().LoginReducer.session;  
    let headers = new Headers()
    headers.append("Authorization",currentToken);
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
    fetch(URL_API_CLIENT_MANAGEMENT_EDIT, {
      method: 'POST',
      headers : headers,
      body:JSON.stringify(prop)
    }).then((res) => res.json())
      .then((data) => {
          if(data.status === 403){
          dispatch(showModalLogin())
         } else {
          dispatch(ErrorManage(data))
          dispatch(InventoryClientAction())
         }   
      })
     .catch(error => { dispatch(ErrorManage(error))
     })
  }
}
export function ReportsMaster(){
  return (dispatch, getState) => {
    const currentToken = getState().LoginReducer.session;  
    let headers = new Headers()
    headers.append("Authorization",currentToken); 
   headers.append('Content-Type','application/json');
   headers.append('Accept','application/json');
    dispatch(ReportsMasterPending());
    fetch(URL_API_REPORTS, {
      method: 'POST',
      headers : headers})
    .then(response => response.json())
    .then((json) => { 
      if(json.status === 403){
        dispatch(showModalLogin())
       } else {
        dispatch(ReportsMasterSuceess(json))
       }  })
    .catch(error => { dispatch(ErrorManage(error)) })
    }
}
export function ReportsMasterPending(){
  return{
    type: 'REPORTS_MASTER_PENDING',
  } 
}
export function ReportsMasterSuceess(data){
  if(data.status === 1001 && !_.isEmpty(data)){
  return{
    type: 'REPORTS_MASTER',
    list: data.value
    } 
  } else {
    return {
      type: "INVENTORY_ERROR", 
      showerror:true, 
      errmessage:data.message,     
    }
  }
}
export function FrequencyMaster(){
  return (dispatch, getState) => {
    const currentToken = getState().LoginReducer.session;  
    let headers = new Headers()
    headers.append("Authorization",currentToken); 
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
    fetch(URL_API_FREQUENCY, {
      method: 'POST',
      headers : headers})
    .then(response => response.json())
    .then((json) => {   
     if(json.status === 403){
      dispatch(showModalLogin())
     } else {
      dispatch(FrequencyMasterSuceess(json))
     } })
    .catch(error => { dispatch(ErrorManage(error)) })  
    }
}
export function FrequencyMasterSuceess(frequencylist){
  if(frequencylist.status === 1001){
  return{
    type: 'FREQUENCY_MASTER',
    freqlist: frequencylist.value
    } 
  } 
}
export function ErrorManage(data){
  return{
    type: "INVENTORY_ERROR", 
    showerror:true, 
    errmessage:data.message,
    isPending:false
  }
}
export function closeModalPopUp(){
  return{
    type:'INVENTORY_MODAL_CLOSE',
    showerror:false
  }
} 



